// cspell:ignore changeup
import { createLevelBuilder } from "../level-builder";

// Good luck debugging any issues in this level.
// More bookmarks helps the debugging process a lot, but a total refactor of the level builder would be better.
export const voxelRevolutionLevel = createLevelBuilder(0)
  .move(15)
  .block(2)
  .move(12)
  .block(6, 1)
  .block(6, 2)
  .move(12)
  .block(1, 1)
  .move(15)
  .spikes(1)
  .move(10)
  .spikes(2)
  .move(4)
  .spikes(2)
  .move(6)

  // Section 2: Tall staircase with big fall - medium difficulty
  .bookmark("staircase-start")
  .move(6)
  .block(5, 2, 0)
  .block(5, 3, 0)
  .block(5, 4, 0)
  .block(5, 5, 0)
  .block(5, 6, 0)
  .block(5, 7, 0)
  .block(5, 8, 0)
  .move(1)
  .block(5, 1, 9)
  .move(1)
  .block(4, 1, 11)
  .move(24)
  .spikes(2)

  .move(22)
  .block(4, 2)

  // harder path (optional floating platforms)
  .move(1)
  .bookmark("section2-floating-start")
  .block(2, 1, 3)
  .move(4)
  .block(2, 1, 4)
  .move(1)
  .block(2, 1, 3)
  .move(4)
  .block(2, 1, 3)
  .move(2)
  .block(3, 1, 1)
  .bookmark("section2-floating-end")
  .gotoBookmark("section2-floating-start")
  .spikes("section2-floating-end")
  .gotoBookmark("section2-floating-end")

  // Some of the comments after this are misleading - don't trust them too much.

  // Section 3: The tricky staircase - higher difficulty
  .move(8)
  .bookmark("staircase2-start")
  .block(2, 1, 1) // Start of staircase
  .move(3)
  .block(2, 1, 2) // Step 2
  .move(3)
  .block(2, 1, 3) // Step 3
  .move(2)
  .block(3, 1, 1) // Lower platform (forces fall)
  .move(3)
  .block(2, 1, 2) // Resume climbing
  .move(3)
  .block(2, 1, 3) // Continue up
  .move(3)
  .block(4, 1, 4) // Top of staircase

  // Fill staircase with spikes underneath
  .bookmark("staircase2-end")
  .gotoBookmark("staircase2-start")
  .spikes("staircase2-end") // Fill with spikes until end bookmark
  .gotoBookmark("staircase2-end")

  // Section 4: Spike gauntlet - high difficulty
  .move(6)
  .spikes(2)
  .move(8)
  .block(1, 1, 2) // Small platform
  .move(8)
  .spikes(3)
  .move(3)
  .block(2, 1, 1) // Safe spot
  .move(3)
  .spikes(3)
  .move(4)
  .block(1, 1, 3) // High platform
  .move(6)
  .spikes(2)
  .move(16)

  // Section 5: Claustrophobic tunnel - expert difficulty (20-30 seconds)
  .block(6, 1) // Start of tunnel
  .block(6, 2)
  .bookmark("tunnel-start")

  // === FIRST HALF ===
  // Ground floor for first half only
  .block(54, 3, 0) // Ground floor for first half only

  // Floor platforms with pits
  .gotoBookmark("tunnel-start")
  .move(5)
  .block(5, 1, 3) // Entry platform
  .move(4) // Medium pit
  .block(6, 1, 3) // Platform
  .move(5) // Longer pit
  .block(4, 1, 3) // Platform
  .move(4) // Medium pit
  .block(7, 1, 3) // Long platform
  .move(4) // Medium pit
  .block(5, 1, 3) // Platform
  .move(5) // Big pit
  .bookmark("tunnel-halfway") // Halfway point bookmark

  // Ceiling platforms for first half
  .gotoBookmark("tunnel-start")
  .move(5)
  .block(7, 1, 7) // Entry ceiling platform
  .move(4) // Gap
  .block(4, 1, 7) // Ceiling platform
  .move(7) // Gap
  .block(6, 1, 7) // Ceiling platform
  .move(4) // Gap
  .block(5, 1, 7) // Ceiling platform
  .move(6) // Gap
  .block(8, 1, 7) // Long ceiling platform
  // === SECOND HALF ===
  .gotoBookmark("tunnel-halfway")
  // // Second half ground floor
  .block(50, 3, 0) // Ground floor for second half

  // Thread the needle section
  .gotoBookmark("tunnel-halfway")
  .move(3) // Approach gap
  .block(2, 1, 4) // Raised floor platform at y=4
  .move(3) // Exit gap

  // Second half - playable zigzag with platforms
  .block(6, 1, 3) // Platform at y=3
  .move(9) // Gap
  .move(3) // Gap
  .block(7, 1, 4) // Higher platform at y=4
  .move(27)
  .bookmark("tunnel-end")

  // Second half ceiling - thread the needle stalactite
  .gotoBookmark("tunnel-halfway")
  .move(4) // Approach gap
  .block(1, 1, 5) // Stalactite top of L shape at y=5 (1 unit gap from raised floor at y=4)
  .move(8) // Exit gap

  // Second half ceilings - irregular pattern
  .block(5, 1, 6) // Ceiling 1 at y=6
  .move(5) // Gap
  .block(3, 1, 7) // Ceiling 2 at y=7
  .move(6) // Gap
  .bookmark("tunnel-3/4-spikes")
  .spikes(12, 1, 4) // 3 spikes at y=5 after stalactite
  .gotoBookmark("tunnel-3/4-spikes")
  .block(4, 1, 6) // Ceiling 3 at y=6
  .move(6) // Gap
  .block(3, 1, 6) // Ceiling 4 at y=6
  .move(8) // Gap
  .block(5, 1, 5) // Ceiling 5 at y=5

  // === MAIN CEILING BACKDROP ===
  .gotoBookmark("tunnel-start")
  .block(80, 10, 8) // Big tall ceiling blocks - visible and claustrophobic

  .gotoBookmark("tunnel-end")
  .block(4, 1, 1)

  // Section 6: Final Gauntlet - extreme difficulty (based on Section 3 pattern)
  .move(8)
  .bookmark("finale-staircase-start")
  .block(2, 1, 1) // Start climbing
  .move(3)
  .block(2, 1, 2) // Step 2
  .move(3)
  .block(2, 1, 3) // Step 3
  .move(2) // Shorter gap - harder
  .block(1, 1, 5) // High jump - air obstacle
  .move(3)
  .block(2, 1, 2) // Fall down (changeup)
  .move(3)
  .block(2, 1, 4) // Climb again
  .move(3) // Shorter gap - harder
  .block(1, 1, 1) // Force fall (changeup)
  .move(3)
  .block(2, 1, 3) // Climb back up
  .move(3)
  .block(2, 1, 5) // High platform
  .move(1) // Shorter gap - harder
  .block(3, 1, 2) // Fall down (changeup)
  .move(2)
  .block(3, 1, 3) // Final high platform
  .bookmark("finale-staircase-end")

  // Air obstacles (floating spikes)
  .gotoBookmark("finale-staircase-start")
  .move(5) // Position above step 2
  .block(1, 1, 8) // Air obstacle at y=4
  .move(8) // Position above fall section
  .block(1, 1, 8) // Air obstacle at y=6
  .move(12) // Position above climb section
  .block(1, 1, 7) // Air obstacle at y=7

  // Fill entire finale with spikes underneath
  .gotoBookmark("finale-staircase-start")
  .spikes("finale-staircase-end") // Fill with spikes until end bookmark
  .gotoBookmark("finale-staircase-end")

  .build("voxel-revolution", "Voxel Revolution", 122, 0.1); // Beat starts 1.5 seconds into the track
